import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function QuickIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_11951_160620" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_11951_160620)"><path d="M24.9993 33.3333C21.2771 33.3333 18.1243 32.0417 15.541 29.4583C12.9577 26.875 11.666 23.7222 11.666 20C11.666 16.2778 12.9577 13.125 15.541 10.5417C18.1243 7.95832 21.2771 6.66666 24.9993 6.66666C28.7216 6.66666 31.8744 7.95832 34.4577 10.5417C37.041 13.125 38.3327 16.2778 38.3327 20C38.3327 23.7222 37.041 26.875 34.4577 29.4583C31.8744 32.0417 28.7216 33.3333 24.9993 33.3333ZM24.9894 30.8333C27.996 30.8333 30.5549 29.7811 32.666 27.6767C34.7771 25.5719 35.8327 23.0164 35.8327 20.01C35.8327 17.0033 34.7805 14.4444 32.676 12.3333C30.5713 10.2222 28.0157 9.16666 25.0093 9.16666C22.0027 9.16666 19.4438 10.2189 17.3327 12.3233C15.2216 14.428 14.166 16.9836 14.166 19.99C14.166 22.9967 15.2182 25.5555 17.3227 27.6667C19.4274 29.7778 21.983 30.8333 24.9894 30.8333ZM29.2494 25.9583L30.9994 24.2083L26.2493 19.4583V13.3333H23.7493V20.5L29.2494 25.9583ZM3.33268 14.5833V12.0833H9.99935V14.5833H3.33268ZM1.66602 21.25V18.75H9.99935V21.25H1.66602ZM3.33268 27.9167V25.4167H9.99935V27.9167H3.33268Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}